module.exports = __webpack_public_path__ + "static/media/image_23.5131b08c.png";